/** Whether a field holds a value; the rule the server applies before it accepts an upload (UploadService.isFilled). */
export function isFilled(field) {
  if (!field) return false;
  switch (field.type) {
    case "TAG":
    case "MULTISELECT":
      return !!(field.arrayValue && field.arrayValue.length);
    case "CHECKBOX":
      return field.booleanValue === true;
    case "DATE":
      return !!(field.dateValue || (field.value || "").trim());
    default:
      return !!(field.value || "").trim();
  }
}

const VALUE_KEYS = ["value", "arrayValue", "booleanValue", "dateValue"];

// Generated models keep unset values on their prototype, where Vue cannot watch them.
export function plainCopy(fields) {
  return JSON.parse(JSON.stringify(fields));
}

/** The same field of another list: by id, or by label and type across sets. */
export function sameField(a, b) {
  return a.id === b.id || (a.label === b.label && a.type === b.type);
}

/** The set most of these fields come from, by field id; null when none of them does. */
export function matchingSet(sets, fields) {
  const ids = new Set(fields.map((field) => field.id));
  const score = (set) => (set.metadata || []).filter((field) => ids.has(field.id)).length;
  const best = sets.reduce((top, set) => (score(set) > score(top) ? set : top), sets[0]);
  return best && score(best) ? best : null;
}

/** Plain copies of a set's fields, each keeping the value its first match in `values` holds. */
export function fieldsOfSet(set, values) {
  return plainCopy(set.metadata || []).map((field) => {
    const match = values.find((other) => sameField(other, field));
    if (match) VALUE_KEYS.filter((key) => match[key] !== undefined).forEach((key) => (field[key] = match[key]));
    return field;
  });
}
